// import React, { useEffect, useRef, useState } from "react";
// import styles from "./Company.module.css";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../components/context/Auth";
// import SettingModal from "../../components/updatedComponents/Settings/SettingModal";
// import {
//   CancelIcon2,
//   DeleteFile,
//   ManagerCameraIcon,
//   NewManagerCreateIcon,
// } from "../../components/icons/Icon";
// import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
// import RadioButtonGroup from "../../components/updatedComponents/FormComponents/RadioButtonGroup";
// import { ModalWrapper } from "../../exports";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import fetchData from "../../APIsControll/apiControll";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
// import Spinner from "../../components/updatedComponents/FormComponents/Spinner";
// import UrlInput from "../../components/updatedComponents/Settings/UrlInput";
// import { applyBranding, saveBranding } from "../../Utils/brandingManager";
// import { useBranding } from "../../components/context/BrandingContext";
// import fetchAcTokenData from "../../APIsControll/fetchAcTokenData";

// const REGEX = {
//   email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
//   mobile: /^[6-9]\d{9}$/, // Indian 10-digit mobile
//   gstuin: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
//   cin: /^[LUu][0-9]{5}[A-Za-z]{2}[0-9]{4}[A-Za-z]{3}[0-9]{6}$/,
//   websiteLink: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w\-./?%&=]*)?$/,
//   pincode: /^[1-9][0-9]{5}$/,
//   facebook: /^(https?:\/\/)?(www\.)?facebook\.com(\/[A-Za-z0-9._-]+)?\/?$/,

//   instagram: /^(https?:\/\/)?(www\.)?instagram\.com(\/[A-Za-z0-9._-]+)?\/?$/,

//   linkedin: /^(https?:\/\/)?(www\.)?linkedin\.com(\/[A-Za-z0-9._/-]+)?\/?$/,

//   twitter: /^(https?:\/\/)?(www\.)?(x|twitter)\.com(\/[A-Za-z0-9_]+)?\/?$/,
// };

// const validateField = (name, value) => {
//   const str = value == null ? "" : String(value);
//   if (!str || str.trim() === "") return "";

//   // For optional fields (social media)
//   if (
//     name !== "websiteLink" &&
//     (!str || str === "https://" || str === "http://")
//   ) {
//     return "";
//   }
//   switch (name) {
//     case "email":
//       return REGEX.email.test(str) ? "" : "Enter a valid email address";
//     case "mobile":
//       return REGEX.mobile.test(str)
//         ? ""
//         : "Enter a valid 10-digit mobile number";
//     case "gstuin":
//       return REGEX.gstuin.test(str.toUpperCase())
//         ? ""
//         : "Enter a valid GSTIN/UIN (e.g. 22AAAAA0000A1Z5)";
//     case "cin":
//       return REGEX.cin.test(str)
//         ? ""
//         : "Enter a valid CIN (e.g. L17110MH1973PLC019786)";
//     case "facebook":
//       return REGEX.facebook.test(str)
//         ? ""
//         : "Enter a valid Facebook URL (e.g. https://facebook.com/username)";

//     case "instagram":
//       return REGEX.instagram.test(str)
//         ? ""
//         : "Enter a valid Instagram URL (e.g. https://instagram.com/username)";

//     case "linkedin":
//       return REGEX.linkedin.test(str)
//         ? ""
//         : "Enter a valid LinkedIn URL (e.g. https://linkedin.com/in/username)";

//     case "twitter":
//       return REGEX.twitter.test(str)
//         ? ""
//         : "Enter a valid X/Twitter URL (e.g. https://x.com/username)";
//     case "websiteLink":
//       return REGEX.websiteLink.test(str)
//         ? ""
//         : "Enter a valid URL (e.g. https://example.com)";
//     case "pincode":
//       return REGEX.pincode.test(str) ? "" : "Enter a valid 6-digit PIN code";
//     default:
//       return "";
//   }
// };

// const Company = ({
//   otpActoken,
//   setOtpAcToken,
//   deviceId,
//   iPInfo,
//   browserName,
//   operatinySystem,

// }) => {
//   const { mode, managerId, setPaymentGatewayAccess, setSettingsData } =
//     useAuth();
//   const navigate = useNavigate();
//   const { setBranding } = useBranding();
//   const { show } = useToast();
//   const textColor = { color: mode ? "#ffffff" : "#646b88" };

//   const companyInputRef = useRef(null);
//   const pgInputRef = useRef(null);

//   const companyLogo = () => (
//     <svg
//       width="40"
//       height="40"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke={mode ? "#ffffff" : "#72788F"}
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <rect x="3" y="3" width="18" height="18" rx="2" />
//       <path d="M9 21V9h6v12" />
//     </svg>
//   );
//   const [errors, setErrors] = useState({});
//   const [previewImage, setPreviewImage] = useState(null);
//   const [logoFile, setLogoFile] = useState(null);
//   const [pgPreviewImage, setPgPreviewImage] = useState(null);
//   const [pgLogoFile, setPgLogoFile] = useState(null);
//   const [loadingData, setLoadingData] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [loadingAddress, setLoadingAddress] = useState(false);
//   const [modalContent, setModalContent] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [refreshKey, setRefreshKey] = useState(0);
//   const [companyData, setCompanyData] = useState({
//     managerId: managerId,
//     companyLogo: "",
//     companyName: "",
//     projectId: "",
//     companyShortName: "",
//     projectName: "",
//     email: "",
//     mobile: "",
//     gstuin: "",
//     cin: "",
//     facebook: "",
//     instagram: "",
//     linkedin: "",
//     twitter: "",
//     pincode: "",
//     street: "",
//     district: "",
//     city: "",
//     state: "",
//     country: "",
//     paymentGatewayAccess: false,
//     websiteLink: "",
//     paymentGatewayName: "",
//     paymentGatewayLogo: "",
//   });

//   // -------------------------------------

//   const DEFAULT_TITLE = "Admin";

//   const DEFAULT_FAVICON = "/favicon.png";

//   //  Reset branding
//   const resetBranding = () => {
//     localStorage.removeItem("branding");

//     // Reset browser branding
//     applyBranding({
//       title: DEFAULT_TITLE,

//       favicon: DEFAULT_FAVICON,
//     });

//     // Reset context branding
//     setBranding({
//       title: DEFAULT_TITLE,

//       favicon: DEFAULT_FAVICON,
//     });
//   };

//   // ---------------------------------------

//   useEffect(() => {
//     const getSettingsData = async () => {
//       setLoadingData(true);

//       try {
//         const res = await fetchAcTokenData(
//           "admin/getSettings",
//           {
//             managerId: managerId,
//           },
//           otpActoken,
//         );

//         if (res.status === "success") {
//           setOtpAcToken(res.actoken);
//           const originalData = res.data[0];
//           setPaymentGatewayAccess(originalData.paymentGatewayAccess);
//           setSettingsData({
//             companyLogo: originalData.companyLogo,
//             companyName: originalData.companyName,
//             paymentGatewayAccess: originalData.paymentGatewayAccess,
//             projectName: originalData.projectName,
//             websiteLink: originalData.paymentGatewayAccess
//               ? originalData.websiteLink
//               : "",
//           });
//           setCompanyData({
//             companyLogo: originalData.companyLogo,
//             companyName: originalData.companyName,
//             projectId: originalData.projectId,
//             companyShortName: originalData.companyShortName,
//             projectName: originalData.projectName,
//             email: originalData.email,
//             mobile: originalData.mobile,
//             gstuin: originalData.gstuin,
//             cin: originalData.cin,
//             facebook: originalData.facebook,
//             instagram: originalData.instagram,
//             linkedin: originalData.linkedin,
//             twitter: originalData.twitter,
//             pincode: String(originalData.pincode || ""),
//             street: originalData.street,
//             district: originalData.district,
//             city: originalData.city,
//             state: originalData.state,
//             country: originalData.country,
//             paymentGatewayAccess: originalData.paymentGatewayAccess,
//             paymentGatewayName: originalData.paymentGatewayName,
//             paymentGatewayLogo: originalData.paymentGatewayLogo,
//             websiteLink: originalData.websiteLink,
//           });

//           setPreviewImage(
//             originalData.companyLogo
//               ? process.env.REACT_APP_S3URL + originalData.companyLogo
//               : null,
//           );

//           setPgPreviewImage(
//             originalData.paymentGatewayLogo
//               ? process.env.REACT_APP_S3URL + originalData.paymentGatewayLogo
//               : null,
//           );

//           const brandingData = {
//             //  Safe Title
//             title:
//               originalData?.projectName &&
//               originalData.projectName.trim() !== ""
//                 ? originalData.projectName
//                 : DEFAULT_TITLE,

//             //  Safe Logo
//             favicon:
//               originalData?.companyLogo &&
//               originalData.companyLogo.trim() !== ""
//                 ? process.env.REACT_APP_S3URL + originalData.companyLogo
//                 : DEFAULT_FAVICON,
//           };

//           //  Apply browser branding
//           applyBranding(brandingData);

//           //  Save localStorage branding
//           saveBranding(brandingData);

//           //  Update Context branding
//           setBranding(brandingData);
//         }
//         if (res?.status === "failed") {
//           resetBranding();
//           // show(res?.msg, "error");
//           localStorage.removeItem("settingsData");
//           setSettingsData({
//             companyLogo: "",
//             companyName: "",
//             paymentGatewayAccess: false,
//             projectName: "",
//             websiteLink: "",
//           });
//         }
//       } catch (error) {
//         resetBranding();
//         console.error("Error fetching Settings data:", error);
//       } finally {
//         setLoadingData(false);
//       }
//     };

//     if (managerId) {
//       getSettingsData();
//     }
//   }, [managerId, refreshKey]);

//   const handleFieldChange = (field, value) => {
//     setCompanyData((prev) => ({ ...prev, [field]: value }));
//     const err = validateField(field, value);
//     setErrors((prev) => ({ ...prev, [field]: err }));
//   };

//   const handlePhotoClick = (ref) => {
//     ref.current.click();
//   };

//   const handleDrop = (e, type) => {
//     e.preventDefault();
//     const file = e.dataTransfer.files[0];
//     handleFile(file, type);
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//   };

//   const handleFile = (file, type) => {
//     if (file && file.type.startsWith("image/")) {
//       const imageUrl = URL.createObjectURL(file);
//       if (type === "company") {
//         setPreviewImage(imageUrl);
//         setLogoFile(file);
//       } else if (type === "pg") {
//         setPgPreviewImage(imageUrl);
//         setPgLogoFile(file);
//       }
//     }
//   };

//   const handlePhotoChange = (event, type) => {
//     const file = event.target.files[0];
//     handleFile(file, type);
//   };

//   const handleRemoveLogo = (type) => {
//     if (type === "company") {
//       setPreviewImage(null);
//       setLogoFile(null);
//       companyInputRef.current.value = "";
//       setCompanyData((prev) => ({ ...prev, companyLogo: "" }));
//     } else if (type === "pg") {
//       setPgPreviewImage(null);
//       setPgLogoFile(null);
//       pgInputRef.current.value = "";
//       setCompanyData((prev) => ({ ...prev, paymentGatewayLogo: "" }));
//     }
//   };

//   const createSettingsData = async () => {
//     setLoading(true);
//     const cleanUrl = (url) => {
//       const str = (url || "").trim();

//       return str === "https://" || str === "http://" ? "" : str;
//     };

//     try {
//       const formData = new FormData();
//       formData.append("managerId", managerId);
//       formData.append("companyName", companyData.companyName);
//       formData.append("projectName", companyData.projectName);
//       formData.append("companyShortName", companyData.companyShortName);
//       formData.append("email", companyData.email);
//       formData.append("mobile", companyData.mobile || "");
//       formData.append("gstuin", companyData.gstuin);
//       formData.append("cin", companyData.cin);
//       formData.append("facebook", cleanUrl(companyData.facebook));
//       formData.append("instagram", cleanUrl(companyData.instagram));
//       formData.append("linkedin", cleanUrl(companyData.linkedin));
//       formData.append("twitter", cleanUrl(companyData.twitter));
//       formData.append("pincode", companyData.pincode);
//       formData.append("street", companyData.street);
//       formData.append("district", companyData.district);
//       formData.append("city", companyData.city);
//       formData.append("state", companyData.state);
//       formData.append("country", companyData.country);
//       formData.append("paymentGatewayAccess", companyData.paymentGatewayAccess);
//       formData.append("paymentGatewayName", companyData.paymentGatewayName);
//       formData.append(
//         "websiteLink",
//         companyData.paymentGatewayAccess ? companyData.websiteLink : "",
//       );
//       if (companyData.projectId) {
//         formData.append("projectId", companyData.projectId);
//       }
//       if (logoFile) {
//         formData.append("companyLogo", logoFile);
//       }
//       if (pgLogoFile) {
//         formData.append("paymentGatewayLogo", pgLogoFile);
//       }

//       const response = await fetch(
//         `${process.env.REACT_APP_URL}admin/addUpSettings`,
//         {
//           method: "POST",
//           headers: {
//             "wa-platform": process.env.REACT_APP_ADMIN_SECRET,
//             actoken: otpActoken,
//           },
//           body: formData,
//         },
//       );

//       const res = await response.json();

//       if (res.status === "success") {
//         setOtpAcToken(res.actoken);
//         show(res.msg, "success");

//         // applyBranding({
//         //   title: companyData.projectName,
//         //   favicon: companyData.companyLogo
//         //     ? process.env.REACT_APP_S3URL + companyData.companyLogo
//         //     : null,
//         // });

//         // saveBranding({
//         //   title: companyData.projectName,
//         //   favicon: companyData.companyLogo
//         //     ? process.env.REACT_APP_S3URL + companyData.companyLogo
//         //     : null,
//         // });

//         handleCloseModal();
//         setRefreshKey((prev) => prev + 1);
//       } else {
//         show(res.msg, "error");
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOpenModal = (content) => {
//     setModalContent(content);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setModalContent(null);
//   };

//   const openSettingsData = () => {
//     const newErrors = {};

//     // Required field
//     if (!companyData.companyName) {
//       newErrors.companyName = "Company name is required";
//     }
//     if (!companyData.projectName) {
//       newErrors.projectName = "Project name is required";
//     }
//     if (!companyData.companyShortName) {
//       newErrors.companyShortName = "Company Short name is required";
//     }

//     if (companyData.paymentGatewayAccess) {
//       if (!companyData.websiteLink) {
//         newErrors.websiteLink = "Website Link is required";
//       }
//     }
//     if (!companyData.paymentGatewayName) {
//       newErrors.paymentGatewayName = "Payment Gateway name is required";
//     }

//     const formatFields = [
//       "email",
//       "mobile",
//       "gstuin",
//       "cin",
//       "facebook",
//       "instagram",
//       "linkedin",
//       "twitter",
//       "pincode",
//     ];
//     formatFields.forEach((field) => {
//       const err = validateField(field, companyData[field]);
//       if (err) newErrors[field] = err;
//     });

//     if (companyData.paymentGatewayAccess) {
//       const err = validateField("websiteLink", companyData.websiteLink);
//       if (err) newErrors.websiteLink = err;
//     }

//     setErrors(newErrors);
//     if (Object.keys(newErrors).length) return;

//     const isUpdate = !!companyData?.projectId;

//     handleOpenModal(
//       <SettingModal
//         heading={`${isUpdate ? "Update" : "Save"} Settings`}
//         centerHeading={`Are you sure you want to ${isUpdate ? "Update" : "Save"}?`}
//         subHeading={`To confirm! type ${isUpdate ? "update" : "save"} in the text field.`}
//         targetWord={isUpdate ? "update" : "save"}
//         handleSubmit={createSettingsData}
//         handleCloseModal={handleCloseModal}
//         focus
//       />,
//     );
//   };

//   useEffect(() => {
//     if (String(companyData.pincode).length === 6) {
//       setLoadingAddress(true);

//       let myHeaders = new Headers();
//       myHeaders.append("wa-platform", process.env.REACT_APP_ADMIN_SECRET);
//       myHeaders.append("Content-Type", "application/json");

//       let raw = JSON.stringify({ keyword: companyData.pincode });

//       fetch(process.env.REACT_APP_URL + "locations/locations", {
//         method: "POST",
//         headers: myHeaders,
//         body: raw,
//       })
//         .then((res) => res.json())
//         .then((result) => {
//           if (result.status === "success") {
//             setCompanyData((prev) => ({
//               ...prev,
//               district: result.SubDistName?.[0]?.toUpperCase() || "",
//               city: result.districts?.[0] || "",
//               state: result.states?.[0] || "",
//               country: "India",
//             }));
//           }
//         })
//         .catch(() => {})
//         .finally(() => {
//           setLoadingAddress(false);
//         });
//     }
//   }, [companyData.pincode]);

//   const PayGetwayOptions = [
//     { label: "Yes", value: true },
//     { label: "No", value: false },
//   ];
//   return (
//     <div className={`${styles.root} ${mode ? styles.dark : styles.light}`}>
//       <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
//         {modalContent}
//       </ModalWrapper>
//       {loadingData ? (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//           className={styles.nm_form}
//         >
//           <Spinner size="15" />
//         </div>
//       ) : (
//         <>
//           <div className={styles.nm_form}>
//             <div className={styles.nm_form_section}>
//               <div
//                 className={`${styles.inp_con} ${mode ? styles.inp_con_dark : ""}`}
//               >
//                 <p
//                   className={styles.wa_heading}
//                   style={{ color: mode ? "#ffffff" : "#72788F" }}
//                 >
//                   Company Details
//                 </p>
//                 <h3 className={styles.sectionTitle}>Company Logo</h3>
//                 <div
//                   className={styles.nm_photo}
//                   onClick={() => handlePhotoClick(companyInputRef)}
//                   onDrop={(e) => handleDrop(e, "company")}
//                   onDragOver={handleDragOver}
//                 >
//                   {!previewImage ? (
//                     <div className={styles.upload_placeholder}>
//                       {companyData?.companyName?.charAt(0)?.toUpperCase() ||
//                         companyLogo()}
//                     </div>
//                   ) : (
//                     <img
//                       src={previewImage}
//                       alt="Company Logo"
//                       onError={() => setPreviewImage(null)}
//                       style={{
//                         filter: !mode ? "brightness(0) saturate(100%)" : "none",
//                       }}
//                     />
//                   )}
//                   {!previewImage ? (
//                     <div className={styles.nm_camera_icon}>
//                       <ManagerCameraIcon />
//                     </div>
//                   ) : (
//                     <div
//                       className={styles.remove_logo_btn}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleRemoveLogo("company");
//                       }}
//                     >
//                       <DeleteFile color={"#F93E3E"} />
//                     </div>
//                   )}
//                   <input
//                     type="file"
//                     ref={companyInputRef}
//                     style={{ display: "none" }}
//                     onChange={(e) => handlePhotoChange(e, "company")}
//                     accept="image/*"
//                   />
//                 </div>
//                 {errors.companyLogo && (
//                   <span className={styles.error}>{errors.companyLogo}</span>
//                 )}

//                 <div className={styles.element}>
//                   <InputTag
//                     name="companyName"
//                     value={companyData.companyName}
//                     labelText={"Company Name"}
//                     placeholderText={"Enter company name"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={50}
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         companyName: e.target.value,
//                       }))
//                     }
//                     star
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.companyName && (
//                     <span className={styles.error}>{errors.companyName}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <InputTag
//                     name="companyShortName"
//                     value={companyData.companyShortName}
//                     labelText={"Short Name"}
//                     placeholderText={"Enter company name in short"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={9}
//                     star
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         companyShortName: e.target.value,
//                       }))
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.companyShortName && (
//                     <span className={styles.error}>
//                       {errors.companyShortName}
//                     </span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <InputTag
//                     name="projectName"
//                     value={companyData.projectName}
//                     labelText={"Project Name"}
//                     placeholderText={"Enter project name"}
//                     placeholderType={"text"}
//                     required={true}
//                     star
//                     maxLength={50}
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         projectName: e.target.value,
//                       }))
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.projectName && (
//                     <span className={styles.error}>{errors.projectName}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <InputTag
//                     name="street"
//                     value={companyData.street}
//                     labelText={"Street Address"}
//                     placeholderText={"Enter street address"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={50}
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         street: e.target.value,
//                       }))
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.street && (
//                     <span className={styles.error}>{errors.street}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <InputTag
//                     name="pincode"
//                     labelText={"PIN Code"}
//                     placeholderType="number"
//                     placeholderText="Enter Pincode"
//                     value={companyData.pincode}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         pincode: value,
//                         city: "",
//                         state: "",
//                         district: "",
//                         country: "",
//                       }));
//                       setErrors((prev) => ({
//                         ...prev,
//                         pincode: validateField("pincode", value),
//                       }));
//                     }}
//                     maxLength={6}
//                     required={true}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.pincode && !loadingAddress && !companyData.city && (
//                     <span className={styles.error}>{errors.pincode}</span>
//                   )}
//                   {loadingAddress && (
//                     <p className={styles.loadingText} style={textColor}>
//                       Loading address
//                     </p>
//                   )}
//                   {!loadingAddress && companyData.city && (
//                     <p className={styles.addressText} style={textColor}>
//                       {companyData.district}, {companyData.city},{" "}
//                       {companyData.state}, {companyData.country}
//                     </p>
//                   )}
//                 </div>

//                 {/* ── Email ── */}
//                 <div className={styles.element}>
//                   <InputTag
//                     name="email"
//                     value={companyData.email}
//                     labelText={"Email"}
//                     placeholderText={"Enter email"}
//                     placeholderType={"email"}
//                     required={true}
//                     maxLength={50}
//                     onChange={(e) => handleFieldChange("email", e.target.value)}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.email && (
//                     <span className={styles.error}>{errors.email}</span>
//                   )}
//                 </div>

//                 {/* ── Mobile ── */}
//                 <div className={styles.element}>
//                   <InputTag
//                     name="mobile"
//                     value={companyData.mobile}
//                     labelText={"Mobile"}
//                     placeholderText={"Enter mobile"}
//                     placeholderType={"number"}
//                     required={true}
//                     maxLength={10}
//                     onChange={(e) =>
//                       handleFieldChange("mobile", e.target.value)
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.mobile && (
//                     <span className={styles.error}>{errors.mobile}</span>
//                   )}
//                 </div>

//                 {/* ── GSTIN/UIN ── */}
//                 <div className={styles.element}>
//                   <InputTag
//                     name="gstuin"
//                     value={companyData.gstuin}
//                     labelText={"GSTIN/UIN"}
//                     placeholderText={"Enter GSTIN/UIN"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={15}
//                     onChange={(e) =>
//                       handleFieldChange("gstuin", e.target.value.toUpperCase())
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.gstuin && (
//                     <span className={styles.error}>{errors.gstuin}</span>
//                   )}
//                 </div>

//                 {/* ── CIN ── */}
//                 <div className={styles.element}>
//                   <InputTag
//                     name="cin"
//                     value={companyData.cin}
//                     labelText={"CIN"}
//                     placeholderText={"Enter CIN"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={21}
//                     onChange={(e) => handleFieldChange("cin", e.target.value)}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.cin && (
//                     <span className={styles.error}>{errors.cin}</span>
//                   )}
//                 </div>

//                 {/* --------Social Url-------- */}
//                 <div className={styles.element}>
//                   <UrlInput
//                     name="facebook"
//                     value={companyData.facebook}
//                     labelText={"Facebook"}
//                     placeholder={"facebook.com/username"}
//                     placeholderText={"Enter facebook Link"}
//                     placeholderType={"text"}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                     onChange={(e) =>
//                       handleFieldChange("facebook", e.target.value)
//                     }
//                   />
//                   {errors.facebook && (
//                     <span className={styles.error}>{errors.facebook}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <UrlInput
//                     name="instagram"
//                     value={companyData.instagram}
//                     labelText={"Instagram"}
//                     placeholder={"instagram.com/username"}
//                     placeholderText={"Enter instagram Link"}
//                     placeholderType={"text"}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                     onChange={(e) =>
//                       handleFieldChange("instagram", e.target.value)
//                     }
//                   />
//                   {errors.instagram && (
//                     <span className={styles.error}>{errors.instagram}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <UrlInput
//                     name="linkedin"
//                     value={companyData.linkedin}
//                     labelText={"Linkedin"}
//                     placeholder={"linkedin.com/in/username"}
//                     placeholderText={"Enter linkedin Link"}
//                     placeholderType={"text"}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                     onChange={(e) =>
//                       handleFieldChange("linkedin", e.target.value)
//                     }
//                   />
//                   {errors.linkedin && (
//                     <span className={styles.error}>{errors.linkedin}</span>
//                   )}
//                 </div>
//                 <div className={styles.element}>
//                   <UrlInput
//                     name="twitter"
//                     value={companyData.twitter}
//                     labelText={"Twitter"}
//                     placeholder={"x.com/username"}
//                     placeholderText={"Enter twitter Link"}
//                     placeholderType={"text"}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                     onChange={(e) =>
//                       handleFieldChange("twitter", e.target.value)
//                     }
//                   />
//                   {errors.twitter && (
//                     <span className={styles.error}>{errors.twitter}</span>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* --------------------- Features Section ---------------------------- */}
//             <div className={styles.nm_form_section}>
//               <div
//                 className={`${styles.inp_con} ${mode ? styles.inp_con_dark : ""}`}
//               >
//                 <p
//                   className={styles.wa_heading}
//                   style={{ color: mode ? "#ffffff" : "#72788F" }}
//                 >
//                   Features
//                 </p>
//                 <div className={styles.marketing}>
//                   <div className={styles.element_2}>
//                     <div className={styles.checkbox_sec}>
//                       <p style={{ color: mode && "#ffffff" }}>
//                         Payment Collection at External Website
//                       </p>
//                       <RadioButtonGroup
//                         key={companyData.paymentGatewayAccess}
//                         options={PayGetwayOptions}
//                         selectedOption={companyData.paymentGatewayAccess}
//                         onChange={(s) =>
//                           setCompanyData((prev) => ({
//                             ...prev,
//                             paymentGatewayAccess: s,
//                           }))
//                         }
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {/* ── Website / Payment Gateway URL ── */}
//                 {companyData.paymentGatewayAccess && (
//                   <div className={styles.element}>
//                     <UrlInput
//                       name="websiteLink"
//                       value={companyData.websiteLink}
//                       labelText={"Website Link"}
//                       placeholder={"example.com"}
//                       placeholderText={"Enter Website Link"}
//                       placeholderType={"text"}
//                       padding={"8px"}
//                       fontSize={"12px"}
//                       onChange={(e) =>
//                         handleFieldChange("websiteLink", e.target.value)
//                       }
//                       star
//                     />
//                     {errors.websiteLink && (
//                       <span className={styles.error}>{errors.websiteLink}</span>
//                     )}
//                   </div>
//                 )}

//                 <h3 className={styles.sectionTitle}>Payment Gateway Logo</h3>

//                 <div className={styles.element}>
//                   <div
//                     className={styles.nm_photo}
//                     onClick={() => handlePhotoClick(pgInputRef)}
//                     onDrop={(e) => handleDrop(e, "pg")}
//                     onDragOver={handleDragOver}
//                   >
//                     {!pgPreviewImage ? (
//                       <div className={styles.upload_placeholder}>
//                         {companyData?.paymentGatewayName
//                           ?.charAt(0)
//                           ?.toUpperCase() || companyLogo()}
//                       </div>
//                     ) : (
//                       <img
//                         src={pgPreviewImage}
//                         alt="Logo"
//                         onError={() => setPgPreviewImage(null)}
//                         style={{
//                           filter: !mode
//                             ? "brightness(0) saturate(100%)"
//                             : "none",
//                         }}
//                       />
//                     )}

//                     {!pgPreviewImage ? (
//                       <div className={styles.nm_camera_icon}>
//                         <ManagerCameraIcon />
//                       </div>
//                     ) : (
//                       <div
//                         className={styles.remove_logo_btn}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleRemoveLogo("pg");
//                         }}
//                       >
//                         <DeleteFile color={"#F93E3E"} />
//                       </div>
//                     )}

//                     <input
//                       type="file"
//                       ref={pgInputRef}
//                       style={{ display: "none" }}
//                       onChange={(e) => handlePhotoChange(e, "pg")}
//                       accept="image/*"
//                     />
//                   </div>
//                 </div>

//                 <div className={styles.element}>
//                   <InputTag
//                     name="paymentGatewayName"
//                     value={companyData.paymentGatewayName}
//                     labelText={"Payment Gateway Name"}
//                     placeholderText={"Enter Payment Gateway name"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={50}
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         paymentGatewayName: e.target.value,
//                       }))
//                     }
//                     star
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.paymentGatewayName && (
//                     <span className={styles.error}>
//                       {errors.paymentGatewayName}
//                     </span>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       <div
//         className={`${styles.nm_footer} ${mode ? styles.nm_footer_dark : ""}`}
//       >
//         <div className={styles.nm_footer_2}>
//           <Button
//             buttonIcon={<CancelIcon2 />}
//             buttonText={"CANCEL"}
//             buttonBgColor={"#000000"}
//             buttonTextColor={"#ffffff"}
//             buttonBorder={"none"}
//             buttonClick={() => navigate(-1)}
//           />
//           <Button
//             buttonIcon={<NewManagerCreateIcon />}
//             buttonText={companyData?.projectId ? "Update" : "Save"}
//             buttonBgColor={"#4164E3"}
//             buttonTextColor={"#ffffff"}
//             buttonBorder={"none"}
//             buttonClick={() => openSettingsData()}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Company;

// ----------------------------- For OTP Verification --------------------------------------------

// import React, { useEffect, useRef, useState } from "react";
// import styles from "./Company.module.css";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../components/context/Auth";
// import SettingModal from "../../components/updatedComponents/Settings/SettingModal";
// import {
//   CancelIcon2,
//   DeleteFile,
//   ManagerCameraIcon,
//   NewManagerCreateIcon,
// } from "../../components/icons/Icon";
// import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
// import RadioButtonGroup from "../../components/updatedComponents/FormComponents/RadioButtonGroup";
// import { ModalWrapper } from "../../exports";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import fetchData from "../../APIsControll/apiControll";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
// import Spinner from "../../components/updatedComponents/FormComponents/Spinner";
// import UrlInput from "../../components/updatedComponents/Settings/UrlInput";
// import { applyBranding, saveBranding } from "../../Utils/brandingManager";
// import { useBranding } from "../../components/context/BrandingContext";
// import fetchAcTokenData from "../../APIsControll/fetchAcTokenData";
// import CompanyOtpVerify from "../../components/updatedComponents/Settings/ComapnyOtpVerify";

// const REGEX = {
//   email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
//   mobile: /^[6-9]\d{9}$/, // Indian 10-digit mobile
//   gstuin: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
//   cin: /^[LUu][0-9]{5}[A-Za-z]{2}[0-9]{4}[A-Za-z]{3}[0-9]{6}$/,
//   websiteLink: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w\-./?%&=]*)?$/,
//   pincode: /^[1-9][0-9]{5}$/,
//   facebook: /^(https?:\/\/)?(www\.)?facebook\.com(\/[A-Za-z0-9._-]+)?\/?$/,

//   instagram: /^(https?:\/\/)?(www\.)?instagram\.com(\/[A-Za-z0-9._-]+)?\/?$/,

//   linkedin: /^(https?:\/\/)?(www\.)?linkedin\.com(\/[A-Za-z0-9._/-]+)?\/?$/,

//   twitter: /^(https?:\/\/)?(www\.)?(x|twitter)\.com(\/[A-Za-z0-9_]+)?\/?$/,
// };

// const validateField = (name, value) => {
//   const str = value == null ? "" : String(value);
//   if (!str || str.trim() === "") return "";

//   // For optional fields (social media)
//   if (
//     name !== "websiteLink" &&
//     (!str || str === "https://" || str === "http://")
//   ) {
//     return "";
//   }
//   switch (name) {
//     case "email":
//       return REGEX.email.test(str) ? "" : "Enter a valid email address";
//     case "mobile":
//       return REGEX.mobile.test(str)
//         ? ""
//         : "Enter a valid 10-digit mobile number";
//     case "gstuin":
//       return REGEX.gstuin.test(str.toUpperCase())
//         ? ""
//         : "Enter a valid GSTIN/UIN (e.g. 22AAAAA0000A1Z5)";
//     case "cin":
//       return REGEX.cin.test(str)
//         ? ""
//         : "Enter a valid CIN (e.g. L17110MH1973PLC019786)";
//     case "facebook":
//       return REGEX.facebook.test(str)
//         ? ""
//         : "Enter a valid Facebook URL (e.g. https://facebook.com/username)";

//     case "instagram":
//       return REGEX.instagram.test(str)
//         ? ""
//         : "Enter a valid Instagram URL (e.g. https://instagram.com/username)";

//     case "linkedin":
//       return REGEX.linkedin.test(str)
//         ? ""
//         : "Enter a valid LinkedIn URL (e.g. https://linkedin.com/in/username)";

//     case "twitter":
//       return REGEX.twitter.test(str)
//         ? ""
//         : "Enter a valid X/Twitter URL (e.g. https://x.com/username)";
//     case "websiteLink":
//       return REGEX.websiteLink.test(str)
//         ? ""
//         : "Enter a valid URL (e.g. https://example.com)";
//     case "pincode":
//       return REGEX.pincode.test(str) ? "" : "Enter a valid 6-digit PIN code";
//     default:
//       return "";
//   }
// };

// const Company = ({
//   otpActoken,
//   setOtpAcToken,
//   deviceId,
//   iPInfo,
//   browserName,
//   operatinySystem,
// }) => {
//   const { mode, managerId, setPaymentGatewayAccess, setSettingsData } =
//     useAuth();
//   const navigate = useNavigate();
//   const { setBranding } = useBranding();
//   const { show } = useToast();
//   const textColor = { color: mode ? "#ffffff" : "#646b88" };

//   const companyInputRef = useRef(null);
//   const pgInputRef = useRef(null);

//   const companyLogo = () => (
//     <svg
//       width="40"
//       height="40"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke={mode ? "#ffffff" : "#72788F"}
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <rect x="3" y="3" width="18" height="18" rx="2" />
//       <path d="M9 21V9h6v12" />
//     </svg>
//   );
//   const [errors, setErrors] = useState({});
//   const [previewImage, setPreviewImage] = useState(null);
//   const [logoFile, setLogoFile] = useState(null);
//   const [pgPreviewImage, setPgPreviewImage] = useState(null);
//   const [pgLogoFile, setPgLogoFile] = useState(null);
//   const [loadingData, setLoadingData] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [loadingAddress, setLoadingAddress] = useState(false);
//   const [modalContent, setModalContent] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [refreshKey, setRefreshKey] = useState(0);
//   const [companyData, setCompanyData] = useState({
//     managerId: managerId,
//     companyLogo: "",
//     companyName: "",
//     projectId: "",
//     companyShortName: "",
//     projectName: "",
//     email: "",
//     mobile: "",
//     gstuin: "",
//     cin: "",
//     facebook: "",
//     instagram: "",
//     linkedin: "",
//     twitter: "",
//     pincode: "",
//     street: "",
//     district: "",
//     city: "",
//     state: "",
//     country: "",
//     paymentGatewayAccess: false,
//     websiteLink: "",
//     paymentGatewayName: "",
//     paymentGatewayLogo: "",
//   });

//   const OTP_LENGTH = 6;

//   const [adminOtp, setAdminOtp] = useState(Array(OTP_LENGTH).fill(""));

//   const [companyOtp, setCompanyOtp] = useState(Array(OTP_LENGTH).fill(""));

//   // -------------------------------------

//   const DEFAULT_TITLE = "Admin";

//   const DEFAULT_FAVICON = "/favicon.png";

//   //  Reset branding
//   const resetBranding = () => {
//     localStorage.removeItem("branding");

//     // Reset browser branding
//     applyBranding({
//       title: DEFAULT_TITLE,

//       favicon: DEFAULT_FAVICON,
//     });

//     // Reset context branding
//     setBranding({
//       title: DEFAULT_TITLE,

//       favicon: DEFAULT_FAVICON,
//     });
//   };

//   // ---------------------------------------

//   useEffect(() => {
//     const getSettingsData = async () => {
//       setLoadingData(true);

//       try {
//         const res = await fetchAcTokenData(
//           "admin/getSettings",
//           {
//             managerId: managerId,
//           },
//           otpActoken,
//         );

//         if (res.status === "success") {
//           setOtpAcToken(res.actoken);
//           const originalData = res.data[0];
//           setPaymentGatewayAccess(originalData.paymentGatewayAccess);
//           setSettingsData({
//             companyLogo: originalData.companyLogo,
//             companyName: originalData.companyName,
//             paymentGatewayAccess: originalData.paymentGatewayAccess,
//             projectName: originalData.projectName,
//             websiteLink: originalData.paymentGatewayAccess
//               ? originalData.websiteLink
//               : "",
//           });
//           setCompanyData({
//             companyLogo: originalData.companyLogo,
//             companyName: originalData.companyName,
//             projectId: originalData.projectId,
//             companyShortName: originalData.companyShortName,
//             projectName: originalData.projectName,
//             email: originalData.email,
//             mobile: originalData.mobile,
//             gstuin: originalData.gstuin,
//             cin: originalData.cin,
//             facebook: originalData.facebook,
//             instagram: originalData.instagram,
//             linkedin: originalData.linkedin,
//             twitter: originalData.twitter,
//             pincode: String(originalData.pincode || ""),
//             street: originalData.street,
//             district: originalData.district,
//             city: originalData.city,
//             state: originalData.state,
//             country: originalData.country,
//             paymentGatewayAccess: originalData.paymentGatewayAccess,
//             paymentGatewayName: originalData.paymentGatewayName,
//             paymentGatewayLogo: originalData.paymentGatewayLogo,
//             websiteLink: originalData.websiteLink,
//           });

//           setPreviewImage(
//             originalData.companyLogo
//               ? process.env.REACT_APP_S3URL + originalData.companyLogo
//               : null,
//           );

//           setPgPreviewImage(
//             originalData.paymentGatewayLogo
//               ? process.env.REACT_APP_S3URL + originalData.paymentGatewayLogo
//               : null,
//           );

//           const brandingData = {
//             //  Safe Title
//             title:
//               originalData?.projectName &&
//               originalData.projectName.trim() !== ""
//                 ? originalData.projectName
//                 : DEFAULT_TITLE,

//             //  Safe Logo
//             favicon:
//               originalData?.companyLogo &&
//               originalData.companyLogo.trim() !== ""
//                 ? process.env.REACT_APP_S3URL + originalData.companyLogo
//                 : DEFAULT_FAVICON,
//           };

//           //  Apply browser branding
//           applyBranding(brandingData);

//           //  Save localStorage branding
//           saveBranding(brandingData);

//           //  Update Context branding
//           setBranding(brandingData);
//         }
//         if (res?.status === "failed") {
//           resetBranding();
//           // show(res?.msg, "error");
//           localStorage.removeItem("settingsData");
//           setSettingsData({
//             companyLogo: "",
//             companyName: "",
//             paymentGatewayAccess: false,
//             projectName: "",
//             websiteLink: "",
//           });
//         }
//       } catch (error) {
//         resetBranding();
//         console.error("Error fetching Settings data:", error);
//       } finally {
//         setLoadingData(false);
//       }
//     };

//     if (managerId) {
//       getSettingsData();
//     }
//   }, [managerId, refreshKey]);

//   const handleFieldChange = (field, value) => {
//     setCompanyData((prev) => ({ ...prev, [field]: value }));
//     const err = validateField(field, value);
//     setErrors((prev) => ({ ...prev, [field]: err }));
//   };

//   const handlePhotoClick = (ref) => {
//     ref.current.click();
//   };

//   const handleDrop = (e, type) => {
//     e.preventDefault();
//     const file = e.dataTransfer.files[0];
//     handleFile(file, type);
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//   };

//   const handleFile = (file, type) => {
//     if (file && file.type.startsWith("image/")) {
//       const imageUrl = URL.createObjectURL(file);
//       if (type === "company") {
//         setPreviewImage(imageUrl);
//         setLogoFile(file);
//       } else if (type === "pg") {
//         setPgPreviewImage(imageUrl);
//         setPgLogoFile(file);
//       }
//     }
//   };

//   const handlePhotoChange = (event, type) => {
//     const file = event.target.files[0];
//     handleFile(file, type);
//   };

//   const handleRemoveLogo = (type) => {
//     if (type === "company") {
//       setPreviewImage(null);
//       setLogoFile(null);
//       companyInputRef.current.value = "";
//       setCompanyData((prev) => ({ ...prev, companyLogo: "" }));
//     } else if (type === "pg") {
//       setPgPreviewImage(null);
//       setPgLogoFile(null);
//       pgInputRef.current.value = "";
//       setCompanyData((prev) => ({ ...prev, paymentGatewayLogo: "" }));
//     }
//   };

//   const handleVerify = async () => {
//     setLoading(true);
//     const cleanUrl = (url) => {
//       const str = (url || "").trim();

//       return str === "https://" || str === "http://" ? "" : str;
//     };

//     try {
//       const formData = new FormData();
//       formData.append("managerId", managerId);
//       formData.append("deviceId", deviceId);

//       // formData.append("ip", iPInfo?.ip);
//       // formData.append("browser", browserName);
//       // formData.append("os", operatinySystem);
//       // formData.append("cityName", iPInfo?.city);
//       // formData.append("stateName", iPInfo?.region);
//       // formData.append("countryName", iPInfo?.country_name);

//       formData.append("ip", iPInfo?.ip || "192.168.1.6");
//       formData.append("browser", browserName || "chrome");
//       formData.append("os", operatinySystem || "window");
//       formData.append("cityName", iPInfo?.city || "lucknow");
//       formData.append("stateName", iPInfo?.region || "uttar pradesh");
//       formData.append("countryName", iPInfo?.country_name || "india");

//       formData.append("companyName", companyData.companyName);
//       formData.append("projectName", companyData.projectName);
//       formData.append("companyShortName", companyData.companyShortName);
//       formData.append("email", companyData.email);
//       formData.append("mobile", companyData.mobile || "");
//       formData.append("gstuin", companyData.gstuin);
//       formData.append("cin", companyData.cin);
//       formData.append("facebook", cleanUrl(companyData.facebook));
//       formData.append("instagram", cleanUrl(companyData.instagram));
//       formData.append("linkedin", cleanUrl(companyData.linkedin));
//       formData.append("twitter", cleanUrl(companyData.twitter));
//       formData.append("pincode", companyData.pincode);
//       formData.append("street", companyData.street);
//       formData.append("district", companyData.district);
//       formData.append("city", companyData.city);
//       formData.append("state", companyData.state);
//       formData.append("country", companyData.country);
//       formData.append("paymentGatewayAccess", companyData.paymentGatewayAccess);
//       formData.append("paymentGatewayName", companyData.paymentGatewayName);
//       formData.append(
//         "websiteLink",
//         companyData.paymentGatewayAccess ? companyData.websiteLink : "",
//       );
//       if (companyData.projectId) {
//         formData.append("projectId", companyData.projectId);
//       }
//       if (logoFile) {
//         formData.append("companyLogo", logoFile);
//       }
//       if (pgLogoFile) {
//         formData.append("paymentGatewayLogo", pgLogoFile);
//       }

//       const response = await fetch(
//         `${process.env.REACT_APP_URL}admin/addUpSettings`,
//         {
//           method: "POST",
//           headers: {
//             "wa-platform": process.env.REACT_APP_ADMIN_SECRET,
//             actoken: otpActoken,
//           },
//           body: formData,
//         },
//       );

//       const res = await response.json();

//       if (res.status === "success") {
//         setOtpAcToken(res.actoken);
//         show(res.msg, "success");

//         // applyBranding({
//         //   title: companyData.projectName,
//         //   favicon: companyData.companyLogo
//         //     ? process.env.REACT_APP_S3URL + companyData.companyLogo
//         //     : null,
//         // });

//         // saveBranding({
//         //   title: companyData.projectName,
//         //   favicon: companyData.companyLogo
//         //     ? process.env.REACT_APP_S3URL + companyData.companyLogo
//         //     : null,
//         // });

//         handleCloseModal();
//         setRefreshKey((prev) => prev + 1);
//       } else {
//         show(res.msg, "error");
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const createSettingsData = async () => {
//     setLoading(true);
//     const cleanUrl = (url) => {
//       const str = (url || "").trim();

//       return str === "https://" || str === "http://" ? "" : str;
//     };

//     try {
//       const formData = new FormData();
//       formData.append("managerId", managerId);
//       formData.append("deviceId", deviceId);

//       // formData.append("ip", iPInfo?.ip);
//       // formData.append("browser", browserName);
//       // formData.append("os", operatinySystem);
//       // formData.append("cityName", iPInfo?.city);
//       // formData.append("stateName", iPInfo?.region);
//       // formData.append("countryName", iPInfo?.country_name);

//       formData.append("ip", iPInfo?.ip || "192.168.1.6");
//       formData.append("browser", browserName || "chrome");
//       formData.append("os", operatinySystem || "window");
//       formData.append("cityName", iPInfo?.city || "lucknow");
//       formData.append("stateName", iPInfo?.region || "uttar pradesh");
//       formData.append("countryName", iPInfo?.country_name || "india");
//       formData.append("adminEmailOtp", adminOtp);
//       formData.append("emailOtp", companyOtp);

//       formData.append("companyName", companyData.companyName);
//       formData.append("projectName", companyData.projectName);
//       formData.append("companyShortName", companyData.companyShortName);
//       formData.append("email", companyData.email);
//       formData.append("mobile", companyData.mobile || "");
//       formData.append("gstuin", companyData.gstuin);
//       formData.append("cin", companyData.cin);
//       formData.append("facebook", cleanUrl(companyData.facebook));
//       formData.append("instagram", cleanUrl(companyData.instagram));
//       formData.append("linkedin", cleanUrl(companyData.linkedin));
//       formData.append("twitter", cleanUrl(companyData.twitter));
//       formData.append("pincode", companyData.pincode);
//       formData.append("street", companyData.street);
//       formData.append("district", companyData.district);
//       formData.append("city", companyData.city);
//       formData.append("state", companyData.state);
//       formData.append("country", companyData.country);
//       formData.append("paymentGatewayAccess", companyData.paymentGatewayAccess);
//       formData.append("paymentGatewayName", companyData.paymentGatewayName);
//       formData.append(
//         "websiteLink",
//         companyData.paymentGatewayAccess ? companyData.websiteLink : "",
//       );
//       if (companyData.projectId) {
//         formData.append("projectId", companyData.projectId);
//       }
//       if (logoFile) {
//         formData.append("companyLogo", logoFile);
//       }
//       if (pgLogoFile) {
//         formData.append("paymentGatewayLogo", pgLogoFile);
//       }

//       const response = await fetch(
//         `${process.env.REACT_APP_URL}admin/addUpSettings`,
//         {
//           method: "POST",
//           headers: {
//             "wa-platform": process.env.REACT_APP_ADMIN_SECRET,
//             actoken: otpActoken,
//           },
//           body: formData,
//         },
//       );

//       const res = await response.json();

//       if (res.status === "success") {
//         setOtpAcToken(res.actoken);
//         show(res.msg, "success");

//         // applyBranding({
//         //   title: companyData.projectName,
//         //   favicon: companyData.companyLogo
//         //     ? process.env.REACT_APP_S3URL + companyData.companyLogo
//         //     : null,
//         // });

//         // saveBranding({
//         //   title: companyData.projectName,
//         //   favicon: companyData.companyLogo
//         //     ? process.env.REACT_APP_S3URL + companyData.companyLogo
//         //     : null,
//         // });

//         handleCloseModal();
//         setRefreshKey((prev) => prev + 1);
//       } else {
//         show(res.msg, "error");
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOpenModal = (content) => {
//     setModalContent(content);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setModalContent(null);
//   };

//   // const openSettingsData = () => {
//   //   const newErrors = {};

//   //   // Required field
//   //   if (!companyData.companyName) {
//   //     newErrors.companyName = "Company name is required";
//   //   }
//   //   if (!companyData.projectName) {
//   //     newErrors.projectName = "Project name is required";
//   //   }
//   //   if (!companyData.companyShortName) {
//   //     newErrors.companyShortName = "Company Short name is required";
//   //   }

//   //   if (companyData.paymentGatewayAccess) {
//   //     if (!companyData.websiteLink) {
//   //       newErrors.websiteLink = "Website Link is required";
//   //     }
//   //   }
//   //   if (!companyData.paymentGatewayName) {
//   //     newErrors.paymentGatewayName = "Payment Gateway name is required";
//   //   }

//   //   const formatFields = [
//   //     "email",
//   //     "mobile",
//   //     "gstuin",
//   //     "cin",
//   //     "facebook",
//   //     "instagram",
//   //     "linkedin",
//   //     "twitter",
//   //     "pincode",
//   //   ];
//   //   formatFields.forEach((field) => {
//   //     const err = validateField(field, companyData[field]);
//   //     if (err) newErrors[field] = err;
//   //   });

//   //   if (companyData.paymentGatewayAccess) {
//   //     const err = validateField("websiteLink", companyData.websiteLink);
//   //     if (err) newErrors.websiteLink = err;
//   //   }

//   //   setErrors(newErrors);
//   //   if (Object.keys(newErrors).length) return;

//   //   const isUpdate = !!companyData?.projectId;

//   //   handleOpenModal(
//   //     <SettingModal
//   //       heading={`${isUpdate ? "Update" : "Save"} Settings`}
//   //       centerHeading={`Are you sure you want to ${isUpdate ? "Update" : "Save"}?`}
//   //       subHeading={`To confirm! type ${isUpdate ? "update" : "save"} in the text field.`}
//   //       targetWord={isUpdate ? "update" : "save"}
//   //       handleSubmit={createSettingsData}
//   //       handleCloseModal={handleCloseModal}
//   //       focus
//   //     />,
//   //   );
//   // };

//   const openSettingsData = () => {
//     const newErrors = {};

//     // Required field
//     if (!companyData.companyName) {
//       newErrors.companyName = "Company name is required";
//     }
//     if (!companyData.projectName) {
//       newErrors.projectName = "Project name is required";
//     }
//     if (!companyData.companyShortName) {
//       newErrors.companyShortName = "Company Short name is required";
//     }

//     if (companyData.paymentGatewayAccess) {
//       if (!companyData.websiteLink) {
//         newErrors.websiteLink = "Website Link is required";
//       }
//     }
//     if (!companyData.paymentGatewayName) {
//       newErrors.paymentGatewayName = "Payment Gateway name is required";
//     }

//     const formatFields = [
//       "email",
//       "mobile",
//       "gstuin",
//       "cin",
//       "facebook",
//       "instagram",
//       "linkedin",
//       "twitter",
//       "pincode",
//     ];
//     formatFields.forEach((field) => {
//       const err = validateField(field, companyData[field]);
//       if (err) newErrors[field] = err;
//     });

//     if (companyData.paymentGatewayAccess) {
//       const err = validateField("websiteLink", companyData.websiteLink);
//       if (err) newErrors.websiteLink = err;
//     }

//     setErrors(newErrors);
//     if (Object.keys(newErrors).length) return;

//     const isUpdate = !!companyData?.projectId;
//     if(isUpdate) {
//     handleVerify()
//     handleOpenModal(
//       // <SettingModal
//       //   heading={`${isUpdate ? "Update" : "Save"} Settings`}
//       //   centerHeading={`Are you sure you want to ${isUpdate ? "Update" : "Save"}?`}
//       //   subHeading={`To confirm! type ${isUpdate ? "update" : "save"} in the text field.`}
//       //   targetWord={isUpdate ? "update" : "save"}
//       //   handleSubmit={createSettingsData}
//       //   handleCloseModal={handleCloseModal}
//       //   focus
//       // />,

//       <CompanyOtpVerify
//         mode={mode}
//         // handleVerify={handleVerify}
//         createSettingsData={createSettingsData}
//         adminOtp={adminOtp}
//         setAdminOtp={setAdminOtp}
//         companyOtp={companyOtp}
//         setCompanyOtp={setCompanyOtp}
//         loading={loading}
//       />,
//     );

//   };
//   };

//   useEffect(() => {
//     if (String(companyData.pincode).length === 6) {
//       setLoadingAddress(true);

//       let myHeaders = new Headers();
//       myHeaders.append("wa-platform", process.env.REACT_APP_ADMIN_SECRET);
//       myHeaders.append("Content-Type", "application/json");

//       let raw = JSON.stringify({ keyword: companyData.pincode });

//       fetch(process.env.REACT_APP_URL + "locations/locations", {
//         method: "POST",
//         headers: myHeaders,
//         body: raw,
//       })
//         .then((res) => res.json())
//         .then((result) => {
//           if (result.status === "success") {
//             setCompanyData((prev) => ({
//               ...prev,
//               district: result.SubDistName?.[0]?.toUpperCase() || "",
//               city: result.districts?.[0] || "",
//               state: result.states?.[0] || "",
//               country: "India",
//             }));
//           }
//         })
//         .catch(() => {})
//         .finally(() => {
//           setLoadingAddress(false);
//         });
//     }
//   }, [companyData.pincode]);

//   const PayGetwayOptions = [
//     { label: "Yes", value: true },
//     { label: "No", value: false },
//   ];
//   return (
//     <div className={`${styles.root} ${mode ? styles.dark : styles.light}`}>
//       <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
//         {modalContent}
//       </ModalWrapper>
//       {loadingData ? (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//           className={styles.nm_form}
//         >
//           <Spinner size="15" />
//         </div>
//       ) : (
//         <>
//           <div className={styles.nm_form}>
//             <div className={styles.nm_form_section}>
//               <div
//                 className={`${styles.inp_con} ${mode ? styles.inp_con_dark : ""}`}
//               >
//                 <p
//                   className={styles.wa_heading}
//                   style={{ color: mode ? "#ffffff" : "#72788F" }}
//                 >
//                   Company Details
//                 </p>
//                 <h3 className={styles.sectionTitle}>Company Logo</h3>
//                 <div
//                   className={styles.nm_photo}
//                   onClick={() => handlePhotoClick(companyInputRef)}
//                   onDrop={(e) => handleDrop(e, "company")}
//                   onDragOver={handleDragOver}
//                 >
//                   {!previewImage ? (
//                     <div className={styles.upload_placeholder}>
//                       {companyData?.companyName?.charAt(0)?.toUpperCase() ||
//                         companyLogo()}
//                     </div>
//                   ) : (
//                     <img
//                       src={previewImage}
//                       alt="Company Logo"
//                       onError={() => setPreviewImage(null)}
//                       style={{
//                         filter: !mode ? "brightness(0) saturate(100%)" : "none",
//                       }}
//                     />
//                   )}
//                   {!previewImage ? (
//                     <div className={styles.nm_camera_icon}>
//                       <ManagerCameraIcon />
//                     </div>
//                   ) : (
//                     <div
//                       className={styles.remove_logo_btn}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleRemoveLogo("company");
//                       }}
//                     >
//                       <DeleteFile color={"#F93E3E"} />
//                     </div>
//                   )}
//                   <input
//                     type="file"
//                     ref={companyInputRef}
//                     style={{ display: "none" }}
//                     onChange={(e) => handlePhotoChange(e, "company")}
//                     accept="image/*"
//                   />
//                 </div>
//                 {errors.companyLogo && (
//                   <span className={styles.error}>{errors.companyLogo}</span>
//                 )}

//                 <div className={styles.element}>
//                   <InputTag
//                     name="companyName"
//                     value={companyData.companyName}
//                     labelText={"Company Name"}
//                     placeholderText={"Enter company name"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={50}
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         companyName: e.target.value,
//                       }))
//                     }
//                     star
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.companyName && (
//                     <span className={styles.error}>{errors.companyName}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <InputTag
//                     name="companyShortName"
//                     value={companyData.companyShortName}
//                     labelText={"Short Name"}
//                     placeholderText={"Enter company name in short"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={9}
//                     star
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         companyShortName: e.target.value,
//                       }))
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.companyShortName && (
//                     <span className={styles.error}>
//                       {errors.companyShortName}
//                     </span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <InputTag
//                     name="projectName"
//                     value={companyData.projectName}
//                     labelText={"Project Name"}
//                     placeholderText={"Enter project name"}
//                     placeholderType={"text"}
//                     required={true}
//                     star
//                     maxLength={50}
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         projectName: e.target.value,
//                       }))
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.projectName && (
//                     <span className={styles.error}>{errors.projectName}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <InputTag
//                     name="street"
//                     value={companyData.street}
//                     labelText={"Street Address"}
//                     placeholderText={"Enter street address"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={50}
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         street: e.target.value,
//                       }))
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.street && (
//                     <span className={styles.error}>{errors.street}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <InputTag
//                     name="pincode"
//                     labelText={"PIN Code"}
//                     placeholderType="number"
//                     placeholderText="Enter Pincode"
//                     value={companyData.pincode}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         pincode: value,
//                         city: "",
//                         state: "",
//                         district: "",
//                         country: "",
//                       }));
//                       setErrors((prev) => ({
//                         ...prev,
//                         pincode: validateField("pincode", value),
//                       }));
//                     }}
//                     maxLength={6}
//                     required={true}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.pincode && !loadingAddress && !companyData.city && (
//                     <span className={styles.error}>{errors.pincode}</span>
//                   )}
//                   {loadingAddress && (
//                     <p className={styles.loadingText} style={textColor}>
//                       Loading address
//                     </p>
//                   )}
//                   {!loadingAddress && companyData.city && (
//                     <p className={styles.addressText} style={textColor}>
//                       {companyData.district}, {companyData.city},{" "}
//                       {companyData.state}, {companyData.country}
//                     </p>
//                   )}
//                 </div>

//                 {/* ── Email ── */}
//                 <div className={styles.element}>
//                   <InputTag
//                     name="email"
//                     value={companyData.email}
//                     labelText={"Email"}
//                     placeholderText={"Enter email"}
//                     placeholderType={"email"}
//                     required={true}
//                     maxLength={50}
//                     onChange={(e) => handleFieldChange("email", e.target.value)}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.email && (
//                     <span className={styles.error}>{errors.email}</span>
//                   )}
//                 </div>

//                 {/* ── Mobile ── */}
//                 <div className={styles.element}>
//                   <InputTag
//                     name="mobile"
//                     value={companyData.mobile}
//                     labelText={"Mobile"}
//                     placeholderText={"Enter mobile"}
//                     placeholderType={"number"}
//                     required={true}
//                     maxLength={10}
//                     onChange={(e) =>
//                       handleFieldChange("mobile", e.target.value)
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.mobile && (
//                     <span className={styles.error}>{errors.mobile}</span>
//                   )}
//                 </div>

//                 {/* ── GSTIN/UIN ── */}
//                 <div className={styles.element}>
//                   <InputTag
//                     name="gstuin"
//                     value={companyData.gstuin}
//                     labelText={"GSTIN/UIN"}
//                     placeholderText={"Enter GSTIN/UIN"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={15}
//                     onChange={(e) =>
//                       handleFieldChange("gstuin", e.target.value.toUpperCase())
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.gstuin && (
//                     <span className={styles.error}>{errors.gstuin}</span>
//                   )}
//                 </div>

//                 {/* ── CIN ── */}
//                 <div className={styles.element}>
//                   <InputTag
//                     name="cin"
//                     value={companyData.cin}
//                     labelText={"CIN"}
//                     placeholderText={"Enter CIN"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={21}
//                     onChange={(e) => handleFieldChange("cin", e.target.value)}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.cin && (
//                     <span className={styles.error}>{errors.cin}</span>
//                   )}
//                 </div>

//                 {/* --------Social Url-------- */}
//                 <div className={styles.element}>
//                   <UrlInput
//                     name="facebook"
//                     value={companyData.facebook}
//                     labelText={"Facebook"}
//                     placeholder={"facebook.com/username"}
//                     placeholderText={"Enter facebook Link"}
//                     placeholderType={"text"}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                     onChange={(e) =>
//                       handleFieldChange("facebook", e.target.value)
//                     }
//                   />
//                   {errors.facebook && (
//                     <span className={styles.error}>{errors.facebook}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <UrlInput
//                     name="instagram"
//                     value={companyData.instagram}
//                     labelText={"Instagram"}
//                     placeholder={"instagram.com/username"}
//                     placeholderText={"Enter instagram Link"}
//                     placeholderType={"text"}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                     onChange={(e) =>
//                       handleFieldChange("instagram", e.target.value)
//                     }
//                   />
//                   {errors.instagram && (
//                     <span className={styles.error}>{errors.instagram}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <UrlInput
//                     name="linkedin"
//                     value={companyData.linkedin}
//                     labelText={"Linkedin"}
//                     placeholder={"linkedin.com/in/username"}
//                     placeholderText={"Enter linkedin Link"}
//                     placeholderType={"text"}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                     onChange={(e) =>
//                       handleFieldChange("linkedin", e.target.value)
//                     }
//                   />
//                   {errors.linkedin && (
//                     <span className={styles.error}>{errors.linkedin}</span>
//                   )}
//                 </div>
//                 <div className={styles.element}>
//                   <UrlInput
//                     name="twitter"
//                     value={companyData.twitter}
//                     labelText={"Twitter"}
//                     placeholder={"x.com/username"}
//                     placeholderText={"Enter twitter Link"}
//                     placeholderType={"text"}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                     onChange={(e) =>
//                       handleFieldChange("twitter", e.target.value)
//                     }
//                   />
//                   {errors.twitter && (
//                     <span className={styles.error}>{errors.twitter}</span>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* --------------------- Features Section ---------------------------- */}
//             <div className={styles.nm_form_section}>
//               <div
//                 className={`${styles.inp_con} ${mode ? styles.inp_con_dark : ""}`}
//               >
//                 <p
//                   className={styles.wa_heading}
//                   style={{ color: mode ? "#ffffff" : "#72788F" }}
//                 >
//                   Features
//                 </p>
//                 <div className={styles.marketing}>
//                   <div className={styles.element_2}>
//                     <div className={styles.checkbox_sec}>
//                       <p style={{ color: mode && "#ffffff" }}>
//                         Payment Collection at External Website
//                       </p>
//                       <RadioButtonGroup
//                         key={companyData.paymentGatewayAccess}
//                         options={PayGetwayOptions}
//                         selectedOption={companyData.paymentGatewayAccess}
//                         onChange={(s) =>
//                           setCompanyData((prev) => ({
//                             ...prev,
//                             paymentGatewayAccess: s,
//                           }))
//                         }
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {/* ── Website / Payment Gateway URL ── */}
//                 {companyData.paymentGatewayAccess && (
//                   <div className={styles.element}>
//                     <UrlInput
//                       name="websiteLink"
//                       value={companyData.websiteLink}
//                       labelText={"Website Link"}
//                       placeholder={"example.com"}
//                       placeholderText={"Enter Website Link"}
//                       placeholderType={"text"}
//                       padding={"8px"}
//                       fontSize={"12px"}
//                       onChange={(e) =>
//                         handleFieldChange("websiteLink", e.target.value)
//                       }
//                       star
//                     />
//                     {errors.websiteLink && (
//                       <span className={styles.error}>{errors.websiteLink}</span>
//                     )}
//                   </div>
//                 )}

//                 <h3 className={styles.sectionTitle}>Payment Gateway Logo</h3>

//                 <div className={styles.element}>
//                   <div
//                     className={styles.nm_photo}
//                     onClick={() => handlePhotoClick(pgInputRef)}
//                     onDrop={(e) => handleDrop(e, "pg")}
//                     onDragOver={handleDragOver}
//                   >
//                     {!pgPreviewImage ? (
//                       <div className={styles.upload_placeholder}>
//                         {companyData?.paymentGatewayName
//                           ?.charAt(0)
//                           ?.toUpperCase() || companyLogo()}
//                       </div>
//                     ) : (
//                       <img
//                         src={pgPreviewImage}
//                         alt="Logo"
//                         onError={() => setPgPreviewImage(null)}
//                         style={{
//                           filter: !mode
//                             ? "brightness(0) saturate(100%)"
//                             : "none",
//                         }}
//                       />
//                     )}

//                     {!pgPreviewImage ? (
//                       <div className={styles.nm_camera_icon}>
//                         <ManagerCameraIcon />
//                       </div>
//                     ) : (
//                       <div
//                         className={styles.remove_logo_btn}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleRemoveLogo("pg");
//                         }}
//                       >
//                         <DeleteFile color={"#F93E3E"} />
//                       </div>
//                     )}

//                     <input
//                       type="file"
//                       ref={pgInputRef}
//                       style={{ display: "none" }}
//                       onChange={(e) => handlePhotoChange(e, "pg")}
//                       accept="image/*"
//                     />
//                   </div>
//                 </div>

//                 <div className={styles.element}>
//                   <InputTag
//                     name="paymentGatewayName"
//                     value={companyData.paymentGatewayName}
//                     labelText={"Payment Gateway Name"}
//                     placeholderText={"Enter Payment Gateway name"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={50}
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         paymentGatewayName: e.target.value,
//                       }))
//                     }
//                     star
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.paymentGatewayName && (
//                     <span className={styles.error}>
//                       {errors.paymentGatewayName}
//                     </span>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       <div
//         className={`${styles.nm_footer} ${mode ? styles.nm_footer_dark : ""}`}
//       >
//         <div className={styles.nm_footer_2}>
//           <Button
//             buttonIcon={<CancelIcon2 />}
//             buttonText={"CANCEL"}
//             buttonBgColor={"#000000"}
//             buttonTextColor={"#ffffff"}
//             buttonBorder={"none"}
//             buttonClick={() => navigate(-1)}
//           />
//           <Button
//             buttonIcon={<NewManagerCreateIcon />}
//             buttonText={companyData?.projectId ? "Update" : "Save"}
//             buttonBgColor={"#4164E3"}
//             buttonTextColor={"#ffffff"}
//             buttonBorder={"none"}
//             buttonClick={() => openSettingsData()}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Company;

// -------------------------- OTP Verifty Working Code -------------------------------------------

import React, { useEffect, useRef, useState } from "react";
import styles from "./Company.module.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../components/context/Auth";
import SettingModal from "../../components/updatedComponents/Settings/SettingModal";
import {
  CancelIcon2,
  DeleteFile,
  ManagerCameraIcon,
  NewManagerCreateIcon,
} from "../../components/icons/Icon";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
import RadioButtonGroup from "../../components/updatedComponents/FormComponents/RadioButtonGroup";
import { ModalWrapper } from "../../exports";
import Button from "../../components/updatedComponents/Dealers/Button";
import fetchData from "../../APIsControll/apiControll";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import Spinner from "../../components/updatedComponents/FormComponents/Spinner";
import UrlInput from "../../components/updatedComponents/Settings/UrlInput";
import { applyBranding, saveBranding } from "../../Utils/brandingManager";
import { useBranding } from "../../components/context/BrandingContext";
import fetchAcTokenData from "../../APIsControll/fetchAcTokenData";
import CompanyOtpVerify from "../../components/updatedComponents/Settings/ComapnyOtpVerify";

const REGEX = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  mobile: /^[6-9]\d{9}$/,
  gstuin: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
  cin: /^[LUu][0-9]{5}[A-Za-z]{2}[0-9]{4}[A-Za-z]{3}[0-9]{6}$/,
  websiteLink: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w\-./?%&=]*)?$/,
  pincode: /^[1-9][0-9]{5}$/,
  facebook: /^(https?:\/\/)?(www\.)?facebook\.com(\/[A-Za-z0-9._-]+)?\/?$/,
  instagram: /^(https?:\/\/)?(www\.)?instagram\.com(\/[A-Za-z0-9._-]+)?\/?$/,
  linkedin: /^(https?:\/\/)?(www\.)?linkedin\.com(\/[A-Za-z0-9._/-]+)?\/?$/,
  twitter: /^(https?:\/\/)?(www\.)?(x|twitter)\.com(\/[A-Za-z0-9_]+)?\/?$/,
};

const validateField = (name, value) => {
  const str = value == null ? "" : String(value);
  if (!str || str.trim() === "") return "";

  if (
    name !== "websiteLink" &&
    (!str || str === "https://" || str === "http://")
  ) {
    return "";
  }
  switch (name) {
    case "email":
      return REGEX.email.test(str) ? "" : "Enter a valid email address";
    case "mobile":
      return REGEX.mobile.test(str)
        ? ""
        : "Enter a valid 10-digit mobile number";
    case "gstuin":
      return REGEX.gstuin.test(str.toUpperCase())
        ? ""
        : "Enter a valid GSTIN/UIN (e.g. 22AAAAA0000A1Z5)";
    case "cin":
      return REGEX.cin.test(str)
        ? ""
        : "Enter a valid CIN (e.g. L17110MH1973PLC019786)";
    case "facebook":
      return REGEX.facebook.test(str)
        ? ""
        : "Enter a valid Facebook URL (e.g. https://facebook.com/username)";
    case "instagram":
      return REGEX.instagram.test(str)
        ? ""
        : "Enter a valid Instagram URL (e.g. https://instagram.com/username)";
    case "linkedin":
      return REGEX.linkedin.test(str)
        ? ""
        : "Enter a valid LinkedIn URL (e.g. https://linkedin.com/in/username)";
    case "twitter":
      return REGEX.twitter.test(str)
        ? ""
        : "Enter a valid X/Twitter URL (e.g. https://x.com/username)";
    case "websiteLink":
      return REGEX.websiteLink.test(str)
        ? ""
        : "Enter a valid URL (e.g. https://example.com)";
    case "pincode":
      return REGEX.pincode.test(str) ? "" : "Enter a valid 6-digit PIN code";
    default:
      return "";
  }
};

const OTP_LENGTH = 6;

const Company = ({
  otpActoken,
  setOtpAcToken,
  deviceId,
  iPInfo,
  browserName,
  operatinySystem,
}) => {
  const { mode, managerId, setPaymentGatewayAccess, setSettingsData } =
    useAuth();
  const navigate = useNavigate();
  const { setBranding } = useBranding();
  const { show } = useToast();
  const textColor = { color: mode ? "#ffffff" : "#646b88" };

  const companyInputRef = useRef(null);
  const pgInputRef = useRef(null);

  const companyLogo = () => (
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke={mode ? "#ffffff" : "#72788F"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M9 21V9h6v12" />
    </svg>
  );

  const [errors, setErrors] = useState({});
  const [previewImage, setPreviewImage] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [pgPreviewImage, setPgPreviewImage] = useState(null);
  const [pgLogoFile, setPgLogoFile] = useState(null);
  const [loadingData, setLoadingData] = useState(true);
  const [loading, setLoading] = useState(false);
  const [sendingOtp, setSendingOtp] = useState(false);
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const [adminOtp, setAdminOtp] = useState(Array(OTP_LENGTH).fill(""));
  const [companyOtp, setCompanyOtp] = useState(Array(OTP_LENGTH).fill(""));

  const [companyData, setCompanyData] = useState({
    managerId: managerId,
    companyLogo: "",
    companyName: "",
    projectId: "",
    companyShortName: "",
    projectName: "",
    email: "",
    mobile: "",
    gstuin: "",
    cin: "",
    facebook: "",
    instagram: "",
    linkedin: "",
    twitter: "",
    pincode: "",
    street: "",
    district: "",
    city: "",
    state: "",
    country: "",
    paymentGatewayAccess: false,
    websiteLink: "",
    paymentGatewayName: "",
    paymentGatewayLogo: "",
  });

  const DEFAULT_TITLE = "Admin";
  const DEFAULT_FAVICON = "/favicon.png";

  const resetBranding = () => {
    localStorage.removeItem("branding");
    applyBranding({ title: DEFAULT_TITLE, favicon: DEFAULT_FAVICON });
    setBranding({ title: DEFAULT_TITLE, favicon: DEFAULT_FAVICON });
  };

  // console.log("otpActoken", otpActoken);

  // ─── Fetch settings on mount ───────────────────────────────────────────────
  useEffect(() => {
    const getSettingsData = async () => {
      setLoadingData(true);
      try {
        const res = await fetchAcTokenData(
          "admin/getSettings",
          { managerId },
          otpActoken,
        );

        if (res.status === "success") {
          setOtpAcToken(res.actoken);
          const d = res.data[0];
          setPaymentGatewayAccess(d.paymentGatewayAccess);
          setSettingsData({
            companyLogo: d.companyLogo,
            companyName: d.companyName,
            paymentGatewayAccess: d.paymentGatewayAccess,
            projectName: d.projectName,
            websiteLink: d.paymentGatewayAccess ? d.websiteLink : "",
          });
          setCompanyData({
            companyLogo: d.companyLogo,
            companyName: d.companyName,
            projectId: d.projectId,
            companyShortName: d.companyShortName,
            projectName: d.projectName,
            email: d.email,
            mobile: d.mobile,
            gstuin: d.gstuin,
            cin: d.cin,
            facebook: d.facebook,
            instagram: d.instagram,
            linkedin: d.linkedin,
            twitter: d.twitter,
            pincode: String(d.pincode || ""),
            street: d.street,
            district: d.district,
            city: d.city,
            state: d.state,
            country: d.country,
            paymentGatewayAccess: d.paymentGatewayAccess,
            paymentGatewayName: d.paymentGatewayName,
            paymentGatewayLogo: d.paymentGatewayLogo,
            websiteLink: d.websiteLink,
          });
          setPreviewImage(
            d.companyLogo ? process.env.REACT_APP_S3URL + d.companyLogo : null,
          );
          setPgPreviewImage(
            d.paymentGatewayLogo
              ? process.env.REACT_APP_S3URL + d.paymentGatewayLogo
              : null,
          );
          const brandingData = {
            title:
              d?.projectName && d.projectName.trim() !== ""
                ? d.projectName
                : DEFAULT_TITLE,
            favicon:
              d?.companyLogo && d.companyLogo.trim() !== ""
                ? process.env.REACT_APP_S3URL + d.companyLogo
                : DEFAULT_FAVICON,
          };
          applyBranding(brandingData);
          saveBranding(brandingData);
          setBranding(brandingData);
        }
        if (res?.status === "failed") {
          resetBranding();
          localStorage.removeItem("settingsData");
          setSettingsData({
            companyLogo: "",
            companyName: "",
            paymentGatewayAccess: false,
            projectName: "",
            websiteLink: "",
          });
        }
      } catch (error) {
        resetBranding();
        console.error("Error fetching Settings data:", error);
      } finally {
        setLoadingData(false);
      }
    };

    if (managerId) getSettingsData();
  }, [managerId, refreshKey]);

  // ─── Build FormData (shared by sendOtp & createSettingsData) ───────────────
  const buildFormData = ({ includeOtp = false } = {}) => {
    const cleanUrl = (url) => {
      const str = (url || "").trim();
      return str === "https://" || str === "http://" ? "" : str;
    };

    const formData = new FormData();
    formData.append("managerId", managerId);
    formData.append("deviceId", deviceId);

    // formData.append("ip", iPInfo?.ip || "192.168.1.6");
    // formData.append("browser", browserName || "chrome");
    // formData.append("os", operatinySystem || "window");
    // formData.append("cityName", iPInfo?.city || "lucknow");
    // formData.append("stateName", iPInfo?.region || "uttar pradesh");
    // formData.append("countryName", iPInfo?.country_name || "india");

    formData.append("ip", iPInfo?.ip);
    formData.append("browser", browserName);
    formData.append("os", operatinySystem);
    formData.append("cityName", iPInfo?.city);
    formData.append("stateName", iPInfo?.region);
    formData.append("countryName", iPInfo?.country_name);

    formData.append("companyName", companyData.companyName);
    formData.append("projectName", companyData.projectName);
    formData.append("companyShortName", companyData.companyShortName);
    formData.append("email", companyData.email);
    formData.append("mobile", companyData.mobile || "");
    formData.append("gstuin", companyData.gstuin);
    formData.append("cin", companyData.cin);
    formData.append("facebook", cleanUrl(companyData.facebook));
    formData.append("instagram", cleanUrl(companyData.instagram));
    formData.append("linkedin", cleanUrl(companyData.linkedin));
    formData.append("twitter", cleanUrl(companyData.twitter));
    formData.append("pincode", companyData.pincode);
    formData.append("street", companyData.street);
    formData.append("district", companyData.district);
    formData.append("city", companyData.city);
    formData.append("state", companyData.state);
    formData.append("country", companyData.country);
    formData.append("paymentGatewayAccess", companyData.paymentGatewayAccess);
    formData.append("paymentGatewayName", companyData.paymentGatewayName);
    formData.append(
      "websiteLink",
      companyData.paymentGatewayAccess ? companyData.websiteLink : "",
    );

    if (companyData.projectId) {
      formData.append("projectId", companyData.projectId);
    }
    if (logoFile) {
      formData.append("companyLogo", logoFile);
    }
    if (pgLogoFile) {
      formData.append("paymentGatewayLogo", pgLogoFile);
    }

    // Only append OTPs when doing the final verified save
    if (includeOtp) {
      formData.append("adminEmailOtp", adminOtp.join(""));
      formData.append("emailOtp", companyOtp.join(""));
    }

    return formData;
  };

  // ─── STEP 1: Send OTP — calls addUpSettings WITHOUT otp fields ─────────────
  // The backend sends OTP emails and returns a pending/otp-sent status.
  const sendOtp = async () => {
    setSendingOtp(true);
    try {
      const formData = buildFormData({ includeOtp: false });

      const response = await fetch(
        `${process.env.REACT_APP_URL}admin/addUpSettings`,
        {
          method: "POST",
          headers: {
            "wa-platform": process.env.REACT_APP_ADMIN_SECRET,
            actoken: otpActoken,
          },
          body: formData,
        },
      );

      const res = await response.json();

      // console.log("sendOTP", res);

      if (res.status === "success") {
        // Update actoken if provided
        if (res.actoken) setOtpAcToken(res.actoken);
        show(res?.msg);
        // Reset OTP fields and open the verification modal
        setAdminOtp(Array(OTP_LENGTH).fill(""));
        setCompanyOtp(Array(OTP_LENGTH).fill(""));
        openOtpModal();
      } else {
        show(res.msg || "Failed to send OTP", "error");
      }
    } catch (err) {
      console.error("sendOtp error:", err);
      show("Something went wrong while sending OTP", "error");
    } finally {
      setSendingOtp(false);
    }
  };

  // ─── STEP 2: Verify OTP — calls addUpSettings WITH otp fields ──────────────
  const createSettingsData = async () => {
    // Basic OTP fill validation
    if (adminOtp.some((d) => d === "")) {
      show("Please enter the Admin OTP", "error");
      return;
    }
    if (companyOtp.some((d) => d === "")) {
      show("Please enter the Profile OTP", "error");
      return;
    }

    setLoading(true);
    try {
      const formData = buildFormData({ includeOtp: true });

      const response = await fetch(
        `${process.env.REACT_APP_URL}admin/addUpSettings`,
        {
          method: "POST",
          headers: {
            "wa-platform": process.env.REACT_APP_ADMIN_SECRET,
            actoken: otpActoken,
          },
          body: formData,
        },
      );

      const res = await response.json();

      // console.log("verifyOTP", res);

      if (res.status === "success") {
        setOtpAcToken(res.actoken);
        show(res.msg, "success");
        handleCloseModal();
        setRefreshKey((prev) => prev + 1);
      } else {
        show(res.msg || "OTP verification failed", "error");
      }
    } catch (err) {
      console.error("createSettingsData error:", err);
      show("Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  // ─── Open OTP modal ────────────────────────────────────────────────────────
  const openOtpModal = () => {
    handleOpenModal(
      <CompanyOtpVerify
        mode={mode}
        createSettingsData={createSettingsData}
        adminOtp={adminOtp}
        setAdminOtp={setAdminOtp}
        companyOtp={companyOtp}
        setCompanyOtp={setCompanyOtp}
        loading={loading}
        onClose={handleCloseModal}
      />,
    );
  };

  // ─── Validate → sendOtp (which opens modal on success) ────────────────────
  const openSettingsData = () => {
    const newErrors = {};

    if (!companyData.companyName) {
      newErrors.companyName = "Company name is required";
    }
    if (!companyData.projectName) {
      newErrors.projectName = "Project name is required";
    }
    if (!companyData.companyShortName) {
      newErrors.companyShortName = "Company Short name is required";
    }
    if (companyData.paymentGatewayAccess) {
      if (!companyData.websiteLink) {
        newErrors.websiteLink = "Website Link is required";
      }
    }
    if (!companyData.paymentGatewayName) {
      newErrors.paymentGatewayName = "Payment Gateway name is required";
    }

    const formatFields = [
      "email",
      "mobile",
      "gstuin",
      "cin",
      "facebook",
      "instagram",
      "linkedin",
      "twitter",
      "pincode",
    ];
    formatFields.forEach((field) => {
      const err = validateField(field, companyData[field]);
      if (err) newErrors[field] = err;
    });

    if (companyData.paymentGatewayAccess) {
      const err = validateField("websiteLink", companyData.websiteLink);
      if (err) newErrors.websiteLink = err;
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length) return;

    // All valid — send OTP first
    sendOtp();
  };

  // ─── Modal helpers ─────────────────────────────────────────────────────────
  const handleOpenModal = (content) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  // ─── OTP modal needs updated refs when state changes ──────────────────────
  // Re-render modal content whenever OTP state or loading changes so that
  // the CompanyOtpVerify component inside the modal always gets fresh props.
  useEffect(() => {
    if (isModalOpen) {
      setModalContent(
        <CompanyOtpVerify
          mode={mode}
          createSettingsData={createSettingsData}
          adminOtp={adminOtp}
          setAdminOtp={setAdminOtp}
          companyOtp={companyOtp}
          setCompanyOtp={setCompanyOtp}
          loading={loading}
          onClose={handleCloseModal}
        />,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminOtp, companyOtp, loading, isModalOpen]);

  const handleFieldChange = (field, value) => {
    setCompanyData((prev) => ({ ...prev, [field]: value }));
    const err = validateField(field, value);
    setErrors((prev) => ({ ...prev, [field]: err }));
  };

  const handlePhotoClick = (ref) => ref.current.click();

  const handleDrop = (e, type) => {
    e.preventDefault();
    handleFile(e.dataTransfer.files[0], type);
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleFile = (file, type) => {
    if (file && file.type.startsWith("image/")) {
      const imageUrl = URL.createObjectURL(file);
      if (type === "company") {
        setPreviewImage(imageUrl);
        setLogoFile(file);
      } else if (type === "pg") {
        setPgPreviewImage(imageUrl);
        setPgLogoFile(file);
      }
    }
  };

  const handlePhotoChange = (event, type) =>
    handleFile(event.target.files[0], type);

  const handleRemoveLogo = (type) => {
    if (type === "company") {
      setPreviewImage(null);
      setLogoFile(null);
      companyInputRef.current.value = "";
      setCompanyData((prev) => ({ ...prev, companyLogo: "" }));
    } else if (type === "pg") {
      setPgPreviewImage(null);
      setPgLogoFile(null);
      pgInputRef.current.value = "";
      setCompanyData((prev) => ({ ...prev, paymentGatewayLogo: "" }));
    }
  };

  useEffect(() => {
    if (String(companyData.pincode).length === 6) {
      setLoadingAddress(true);
      let myHeaders = new Headers();
      myHeaders.append("wa-platform", process.env.REACT_APP_ADMIN_SECRET);
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.REACT_APP_URL + "locations/locations", {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ keyword: companyData.pincode }),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.status === "success") {
            setCompanyData((prev) => ({
              ...prev,
              district: result.SubDistName?.[0]?.toUpperCase() || "",
              city: result.districts?.[0] || "",
              state: result.states?.[0] || "",
              country: "India",
            }));
          }
        })
        .catch(() => {})
        .finally(() => setLoadingAddress(false));
    }
  }, [companyData.pincode]);

  const PayGetwayOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  return (
    <div className={`${styles.root} ${mode ? styles.dark : styles.light}`}>
      <ModalWrapper
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        flag="alwaysopen"
      >
        {modalContent}
      </ModalWrapper>

      {loadingData ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className={styles.nm_form}
        >
          <Spinner size="15" />
        </div>
      ) : (
        <>
          <div className={styles.nm_form}>
            {/* ── Company Details ── */}
            <div className={styles.nm_form_section}>
              <div
                className={`${styles.inp_con} ${mode ? styles.inp_con_dark : ""}`}
              >
                <p
                  className={styles.wa_heading}
                  style={{ color: mode ? "#ffffff" : "#72788F" }}
                >
                  Company Details
                </p>
                <h3 className={styles.sectionTitle}>Company Logo</h3>
                <div
                  className={styles.nm_photo}
                  onClick={() => handlePhotoClick(companyInputRef)}
                  onDrop={(e) => handleDrop(e, "company")}
                  onDragOver={handleDragOver}
                >
                  {!previewImage ? (
                    <div className={styles.upload_placeholder}>
                      {companyData?.companyName?.charAt(0)?.toUpperCase() ||
                        companyLogo()}
                    </div>
                  ) : (
                    <img
                      src={previewImage}
                      alt="Company Logo"
                      onError={() => setPreviewImage(null)}
                      style={{
                        filter: !mode ? "brightness(0) saturate(100%)" : "none",
                      }}
                    />
                  )}
                  {!previewImage ? (
                    <div className={styles.nm_camera_icon}>
                      <ManagerCameraIcon />
                    </div>
                  ) : (
                    <div
                      className={styles.remove_logo_btn}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveLogo("company");
                      }}
                    >
                      <DeleteFile color={"#F93E3E"} />
                    </div>
                  )}
                  <input
                    type="file"
                    ref={companyInputRef}
                    style={{ display: "none" }}
                    onChange={(e) => handlePhotoChange(e, "company")}
                    accept="image/*"
                  />
                </div>
                {errors.companyLogo && (
                  <span className={styles.error}>{errors.companyLogo}</span>
                )}

                <div className={styles.element}>
                  <InputTag
                    name="companyName"
                    value={companyData.companyName}
                    labelText={"Company Name"}
                    placeholderText={"Enter company name"}
                    placeholderType={"text"}
                    required={true}
                    maxLength={50}
                    onChange={(e) =>
                      setCompanyData((prev) => ({
                        ...prev,
                        companyName: e.target.value,
                      }))
                    }
                    star
                    padding={"8px"}
                    fontSize={"12px"}
                  />
                  {errors.companyName && (
                    <span className={styles.error}>{errors.companyName}</span>
                  )}
                </div>

                <div className={styles.element}>
                  <InputTag
                    name="companyShortName"
                    value={companyData.companyShortName}
                    labelText={"Short Name"}
                    placeholderText={"Enter company name in short"}
                    placeholderType={"text"}
                    required={true}
                    maxLength={9}
                    star
                    onChange={(e) =>
                      setCompanyData((prev) => ({
                        ...prev,
                        companyShortName: e.target.value,
                      }))
                    }
                    padding={"8px"}
                    fontSize={"12px"}
                  />
                  {errors.companyShortName && (
                    <span className={styles.error}>
                      {errors.companyShortName}
                    </span>
                  )}
                </div>

                <div className={styles.element}>
                  <InputTag
                    name="projectName"
                    value={companyData.projectName}
                    labelText={"Project Name"}
                    placeholderText={"Enter project name"}
                    placeholderType={"text"}
                    required={true}
                    star
                    maxLength={50}
                    onChange={(e) =>
                      setCompanyData((prev) => ({
                        ...prev,
                        projectName: e.target.value,
                      }))
                    }
                    padding={"8px"}
                    fontSize={"12px"}
                  />
                  {errors.projectName && (
                    <span className={styles.error}>{errors.projectName}</span>
                  )}
                </div>

                <div className={styles.element}>
                  <InputTag
                    name="street"
                    value={companyData.street}
                    labelText={"Street Address"}
                    placeholderText={"Enter street address"}
                    placeholderType={"text"}
                    required={true}
                    maxLength={50}
                    onChange={(e) =>
                      setCompanyData((prev) => ({
                        ...prev,
                        street: e.target.value,
                      }))
                    }
                    padding={"8px"}
                    fontSize={"12px"}
                  />
                  {errors.street && (
                    <span className={styles.error}>{errors.street}</span>
                  )}
                </div>

                <div className={styles.element}>
                  <InputTag
                    name="pincode"
                    labelText={"PIN Code"}
                    placeholderType="number"
                    placeholderText="Enter Pincode"
                    value={companyData.pincode}
                    onChange={(e) => {
                      const value = e.target.value;
                      setCompanyData((prev) => ({
                        ...prev,
                        pincode: value,
                        city: "",
                        state: "",
                        district: "",
                        country: "",
                      }));
                      setErrors((prev) => ({
                        ...prev,
                        pincode: validateField("pincode", value),
                      }));
                    }}
                    maxLength={6}
                    required={true}
                    padding={"8px"}
                    fontSize={"12px"}
                  />
                  {errors.pincode && !loadingAddress && !companyData.city && (
                    <span className={styles.error}>{errors.pincode}</span>
                  )}
                  {loadingAddress && (
                    <p className={styles.loadingText} style={textColor}>
                      Loading address
                    </p>
                  )}
                  {!loadingAddress && companyData.city && (
                    <p className={styles.addressText} style={textColor}>
                      {companyData.district}, {companyData.city},{" "}
                      {companyData.state}, {companyData.country}
                    </p>
                  )}
                </div>

                <div className={styles.element}>
                  <InputTag
                    name="email"
                    value={companyData.email}
                    labelText={"Email"}
                    placeholderText={"Enter email"}
                    placeholderType={"email"}
                    required={true}
                    maxLength={50}
                    onChange={(e) => handleFieldChange("email", e.target.value)}
                    padding={"8px"}
                    fontSize={"12px"}
                  />
                  {errors.email && (
                    <span className={styles.error}>{errors.email}</span>
                  )}
                </div>

                <div className={styles.element}>
                  <InputTag
                    name="mobile"
                    value={companyData.mobile}
                    labelText={"Mobile"}
                    placeholderText={"Enter mobile"}
                    placeholderType={"number"}
                    required={true}
                    maxLength={10}
                    onChange={(e) =>
                      handleFieldChange("mobile", e.target.value)
                    }
                    padding={"8px"}
                    fontSize={"12px"}
                  />
                  {errors.mobile && (
                    <span className={styles.error}>{errors.mobile}</span>
                  )}
                </div>

                <div className={styles.element}>
                  <InputTag
                    name="gstuin"
                    value={companyData.gstuin}
                    labelText={"GSTIN/UIN"}
                    placeholderText={"Enter GSTIN/UIN"}
                    placeholderType={"text"}
                    required={true}
                    maxLength={15}
                    onChange={(e) =>
                      handleFieldChange("gstuin", e.target.value.toUpperCase())
                    }
                    padding={"8px"}
                    fontSize={"12px"}
                  />
                  {errors.gstuin && (
                    <span className={styles.error}>{errors.gstuin}</span>
                  )}
                </div>

                <div className={styles.element}>
                  <InputTag
                    name="cin"
                    value={companyData.cin}
                    labelText={"CIN"}
                    placeholderText={"Enter CIN"}
                    placeholderType={"text"}
                    required={true}
                    maxLength={21}
                    onChange={(e) => handleFieldChange("cin", e.target.value)}
                    padding={"8px"}
                    fontSize={"12px"}
                  />
                  {errors.cin && (
                    <span className={styles.error}>{errors.cin}</span>
                  )}
                </div>

                <div className={styles.element}>
                  <UrlInput
                    name="facebook"
                    value={companyData.facebook}
                    labelText={"Facebook"}
                    placeholder={"facebook.com/username"}
                    placeholderText={"Enter facebook Link"}
                    placeholderType={"text"}
                    padding={"8px"}
                    fontSize={"12px"}
                    onChange={(e) =>
                      handleFieldChange("facebook", e.target.value)
                    }
                  />
                  {errors.facebook && (
                    <span className={styles.error}>{errors.facebook}</span>
                  )}
                </div>

                <div className={styles.element}>
                  <UrlInput
                    name="instagram"
                    value={companyData.instagram}
                    labelText={"Instagram"}
                    placeholder={"instagram.com/username"}
                    placeholderText={"Enter instagram Link"}
                    placeholderType={"text"}
                    padding={"8px"}
                    fontSize={"12px"}
                    onChange={(e) =>
                      handleFieldChange("instagram", e.target.value)
                    }
                  />
                  {errors.instagram && (
                    <span className={styles.error}>{errors.instagram}</span>
                  )}
                </div>

                <div className={styles.element}>
                  <UrlInput
                    name="linkedin"
                    value={companyData.linkedin}
                    labelText={"Linkedin"}
                    placeholder={"linkedin.com/in/username"}
                    placeholderText={"Enter linkedin Link"}
                    placeholderType={"text"}
                    padding={"8px"}
                    fontSize={"12px"}
                    onChange={(e) =>
                      handleFieldChange("linkedin", e.target.value)
                    }
                  />
                  {errors.linkedin && (
                    <span className={styles.error}>{errors.linkedin}</span>
                  )}
                </div>

                <div className={styles.element}>
                  <UrlInput
                    name="twitter"
                    value={companyData.twitter}
                    labelText={"Twitter"}
                    placeholder={"x.com/username"}
                    placeholderText={"Enter twitter Link"}
                    placeholderType={"text"}
                    padding={"8px"}
                    fontSize={"12px"}
                    onChange={(e) =>
                      handleFieldChange("twitter", e.target.value)
                    }
                  />
                  {errors.twitter && (
                    <span className={styles.error}>{errors.twitter}</span>
                  )}
                </div>
              </div>
            </div>

            {/* ── Features Section ── */}
            <div className={styles.nm_form_section}>
              <div
                className={`${styles.inp_con} ${mode ? styles.inp_con_dark : ""}`}
              >
                <p
                  className={styles.wa_heading}
                  style={{ color: mode ? "#ffffff" : "#72788F" }}
                >
                  Features
                </p>
                <div className={styles.marketing}>
                  <div className={styles.element_2}>
                    <div className={styles.checkbox_sec}>
                      <p style={{ color: mode && "#ffffff" }}>
                        Payment Collection at External Website
                      </p>
                      <RadioButtonGroup
                        key={companyData.paymentGatewayAccess}
                        options={PayGetwayOptions}
                        selectedOption={companyData.paymentGatewayAccess}
                        onChange={(s) =>
                          setCompanyData((prev) => ({
                            ...prev,
                            paymentGatewayAccess: s,
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>

                {companyData.paymentGatewayAccess && (
                  <div className={styles.element}>
                    <UrlInput
                      name="websiteLink"
                      value={companyData.websiteLink}
                      labelText={"Website Link"}
                      placeholder={"example.com"}
                      placeholderText={"Enter Website Link"}
                      placeholderType={"text"}
                      padding={"8px"}
                      fontSize={"12px"}
                      onChange={(e) =>
                        handleFieldChange("websiteLink", e.target.value)
                      }
                      star
                    />
                    {errors.websiteLink && (
                      <span className={styles.error}>{errors.websiteLink}</span>
                    )}
                  </div>
                )}

                <h3 className={styles.sectionTitle}>Payment Gateway Logo</h3>
                <div className={styles.element}>
                  <div
                    className={styles.nm_photo}
                    onClick={() => handlePhotoClick(pgInputRef)}
                    onDrop={(e) => handleDrop(e, "pg")}
                    onDragOver={handleDragOver}
                  >
                    {!pgPreviewImage ? (
                      <div className={styles.upload_placeholder}>
                        {companyData?.paymentGatewayName
                          ?.charAt(0)
                          ?.toUpperCase() || companyLogo()}
                      </div>
                    ) : (
                      <img
                        src={pgPreviewImage}
                        alt="Logo"
                        onError={() => setPgPreviewImage(null)}
                        style={{
                          filter: !mode
                            ? "brightness(0) saturate(100%)"
                            : "none",
                        }}
                      />
                    )}
                    {!pgPreviewImage ? (
                      <div className={styles.nm_camera_icon}>
                        <ManagerCameraIcon />
                      </div>
                    ) : (
                      <div
                        className={styles.remove_logo_btn}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveLogo("pg");
                        }}
                      >
                        <DeleteFile color={"#F93E3E"} />
                      </div>
                    )}
                    <input
                      type="file"
                      ref={pgInputRef}
                      style={{ display: "none" }}
                      onChange={(e) => handlePhotoChange(e, "pg")}
                      accept="image/*"
                    />
                  </div>
                </div>

                <div className={styles.element}>
                  <InputTag
                    name="paymentGatewayName"
                    value={companyData.paymentGatewayName}
                    labelText={"Payment Gateway Name"}
                    placeholderText={"Enter Payment Gateway name"}
                    placeholderType={"text"}
                    required={true}
                    maxLength={50}
                    onChange={(e) =>
                      setCompanyData((prev) => ({
                        ...prev,
                        paymentGatewayName: e.target.value,
                      }))
                    }
                    star
                    padding={"8px"}
                    fontSize={"12px"}
                  />
                  {errors.paymentGatewayName && (
                    <span className={styles.error}>
                      {errors.paymentGatewayName}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <div
        className={`${styles.nm_footer} ${mode ? styles.nm_footer_dark : ""}`}
      >
        <div className={styles.nm_footer_2}>
          <Button
            buttonIcon={<CancelIcon2 />}
            buttonText={"CANCEL"}
            buttonBgColor={"#000000"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            buttonClick={() => navigate(-1)}
          />
          <Button
            buttonIcon={<NewManagerCreateIcon />}
            buttonText={
              sendingOtp
                ? "Sending OTP..."
                : companyData?.projectId
                  ? "Update"
                  : "Save"
            }
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            disabled={sendingOtp}
            buttonClick={() => openSettingsData()}
          />
        </div>
      </div>
    </div>
  );
};

export default Company;
